import MappingAction from '../constants/MappingAction';
import { ArgTypes } from '../utils/ArgValidation';
import AttributeId from './AttributeId';
import { getModelHelpers, InferConstructorArgTypes, InferReadTypes } from './Model';

class MappingChange extends getModelHelpers({
  sourceAttribute: { type: ArgTypes.instanceOf(AttributeId) },
  unifiedAttribute: { type: ArgTypes.string },
  action: { type: MappingAction.argType },
}, 'MappingChange')(({ RecordClass, typesAndDefaults, checkConstructorArgs, checkSetArgs }) => {
  type ConstructorArgTypes = InferConstructorArgTypes<typeof typesAndDefaults>;
  type ReadTypes = InferReadTypes<typeof typesAndDefaults>;
  return class MappingChangeRecord extends RecordClass {
    constructor(args: ConstructorArgTypes) {
      checkConstructorArgs(args);
      super(args);
    }
    set<T extends keyof ReadTypes>(name: T, value: ReadTypes[T]) {
      checkSetArgs(name, value);
      return super.set(name, value);
    }
  };
}) {
  static get argType() { return ArgTypes.instanceOf(this); }

  static map(source: AttributeId, unified: AttributeId) {
    return new MappingChange({ sourceAttribute: source, unifiedAttribute: unified.name, action: MappingAction.MAP });
  }

  static unmap(source: AttributeId, unified: AttributeId) {
    return new MappingChange({ sourceAttribute: source, unifiedAttribute: unified.name, action: MappingAction.UNMAP });
  }
}

export default MappingChange;
